export default "__VITE_ASSET__B_D7qHoU__"